import { render, staticRenderFns } from "./Submitted.vue?vue&type=template&id=1bee70bf&scoped=true&"
import script from "./Submitted.vue?vue&type=script&lang=js&"
export * from "./Submitted.vue?vue&type=script&lang=js&"
import style0 from "./Submitted.vue?vue&type=style&index=0&id=1bee70bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bee70bf",
  null
  
)

export default component.exports